import { createFileRoute } from "@tanstack/react-router";
import { ClientDetails } from "../../clients/ClientDetails";

export const Route = createFileRoute("/kunden/$clientId")({
  loader: ({ context: { queryClient, trpc }, params: { clientId } }) => {
    void queryClient.ensureQueryData(
      trpc.clients.getClient.queryOptions({ clientId })
    );
  },
  component: ClientDetailsRoute,
});

function ClientDetailsRoute() {
  const { clientId } = Route.useParams();
  return <ClientDetails clientId={clientId} />;
}
